import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateRequirement,
  getRequirementList,
  updateList,
  showRequirement,
  id,
  history,
  updating
}) {
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    note: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    return updateRequirement(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getRequirementList();
      history.push(`/general-settings/requirements/${_.get(data, 'id')}`);
      showRequirement(_.get(data, "id"));
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description:
            </label>
            <textarea
              className="form-control"
              type="text"
              name="description"
              rows={5}
              onChange={onChange}
              value={_.get(formData, 'description') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Note: 
            </label>
            <textarea
              className="form-control"
              type="text"
              name="note"
              rows={5}
              onChange={onChange}
              value={_.get(formData, 'note') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button 
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={updating || !validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateRequirement: PropTypes.instanceOf(Function).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_REQUIREMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
